import React, { Fragment, useEffect } from "react";
import Loading from "components/explore/prospector/layout/Loading";
import PropertyDetails from "components/explore/prospector/addProperty/PropertyDetails"
import MapCard from "components/explore/prospector/map/MapCard";
import { withSnackbar } from 'notistack';
import PageWrapper from "components/explore/prospector/layout/PageWrapper";
import Page from "components/explore/prospector/layout/Page";

function ManuallyAddProperty({ history, match, enqueueSnackbar, userLocation, refreshProspectsGrid, setRefreshProspectsGrid, handleUserLocationButtonClick, locationStatus }) {
  const [details, setDetails] = React.useState(null);
  async function getUserLocation() {
    try {
      if (userLocation) {
        setDetails({ ...details, address: {
          streetAddress: '',
          city: '',
          state: '',
          zipCode: null, 
        }, location: userLocation });
      } else {
          setDetails({
            ...details,
            address: {
              streetAddress: '',
              city: '',
              state: '',
              zipCode: null
            }
          })
      }
    } catch (err) {
      console.error(err);
      enqueueSnackbar("Failed to load property details", { variant: "error", autoHideDuration: 3000 });
      setDetails("redirect");
    }
  }
  useEffect(() => {
    getUserLocation();
  }, [userLocation]);
  // const loading = details == null;
  function renderLoading() {
    return (
      <Loading message="Loading Property Info" />
    )
  }

  function renderDetails(details, setDetails) {
    return (
      <Fragment>
        <MapCard pin={details.location} isManuallyAdded={true} details={details} setDetails={setDetails}/>
        <PropertyDetails history={history} details={details} isManuallyAdded={true} refreshProspectsGrid={refreshProspectsGrid} 
          setRefreshProspectsGrid={setRefreshProspectsGrid} 
          handleUserLocationButtonClick={() => {
            console.log('handle user button click');
            handleUserLocationButtonClick();
            getUserLocation();
            }
          } 
          userLocation={userLocation} locationStatus={locationStatus} />
      </Fragment>
    )
  }

  return (
    <Page>
      <PageWrapper>
        {details == null ? renderLoading() : renderDetails(details, setDetails)}
      </PageWrapper>
    </Page>
  )
}

export default withSnackbar(ManuallyAddProperty);